var _mask, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_6_43",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85157 5.99989L11.5246 0H0.475342L5.14841 5.99989L0.475342 11.9998H11.5246L6.85157 5.99989Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5246 0L12.3136 0.614472L13.571 -1H11.5246V0ZM6.85157 5.99989L6.06263 5.38542L5.58405 5.99989L6.06263 6.61437L6.85157 5.99989ZM0.475342 0V-1H-1.57104L-0.313597 0.614472L0.475342 0ZM5.14841 5.99989L5.93735 6.61437L6.41594 5.99989L5.93735 5.38542L5.14841 5.99989ZM0.475342 11.9998L-0.313597 11.3853L-1.57104 12.9998H0.475342V11.9998ZM11.5246 11.9998V12.9998H13.571L12.3136 11.3853L11.5246 11.9998ZM10.7357 -0.614472L6.06263 5.38542L7.64051 6.61437L12.3136 0.614472L10.7357 -0.614472ZM0.475342 1H11.5246V-1H0.475342V1ZM5.93735 5.38542L1.26428 -0.614472L-0.313597 0.614472L4.35947 6.61437L5.93735 5.38542ZM4.35947 5.38542L-0.313597 11.3853L1.26428 12.6143L5.93735 6.61437L4.35947 5.38542ZM0.475342 12.9998H11.5246V10.9998H0.475342V12.9998ZM12.3136 11.3853L7.64051 5.38542L6.06263 6.61437L10.7357 12.6143L12.3136 11.3853Z",
    fill: "#CF833D",
    mask: "url(#path-1-inside-1_6_43)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/Pending.8ae8111db75a080c491139c7caa90e3b.svg";
export { ForwardRef as ReactComponent };